export const taskConstants = {
  ADD_TASK: 'NEW_TASK',
  ADD_TASK_LOADING: 'ADD_TASK_LOADING',
  ADD_TASK_FAIL: 'ADD_TASK_FAIL',

  READ_TASKS: 'READ_TASKS',
  READ_TASKS_LOADING: 'READ_TASKS_LOADING',
  READ_TASKS_FAIL: 'READ_TASKS_FAIL',

  UPDATE_TASK: 'UPDATE_TASK',
  UPDATE_TASK_LOADING: 'UPDATE_TASK_LOADING',
  UPDATE_TASK_FAIL: 'UPDATE_TASK_FAIL',

  DONE_STATUS_TASK: 'DONE_STATUS_TASK',
  DONE_STATUS_TASK_FAIL: 'DONE_STATUS_TASK_FAIL',

  DELETE_TASK: 'DELETE_TASK',
  DELETE_TASK_LOADING: 'DELETE_TASK_LOADING',
  DELETE_TASK_FAIL: 'DELETE_TASK_FAIL',
};

export const userConstants = {
  ADD_USER: 'NEW_USER',
  ADD_USER_LOADING: 'ADD_USER_LOADING',
  ADD_USER_FAIL: 'ADD_USER_FAIL',

  DELETE_USER: 'DELETE_USER',
  DELETE_USER_FAIL: 'DELETE_USER_FAIL',
};

export const sessionConstants = {
  LOGIN_USER: 'LOGIN_USER',
  LOGIN_USER_LOADING: 'LOGIN_USER_LOADING',
  LOGIN_USER_FAIL: 'LOGIN_USER_FAIL',

  LOGOUT_USER: 'LOGOUT_USER',
};

export const themeConstants = {
  DARK_THEME: 'DARK_THEME',
  LIGHT_THEME: 'LIGHT_THEME',
};
